import React, { useState } from 'react'
import Header from '../../../common/header/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import { Book_Pooja } from '../../../../api/pooja/Pooja'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { toast } from "react-toastify";
import { IMG_BASE_URL } from '../../../../config/Config'
import Razor_Pay from '../../../../razor_pay/Razor_Pay'

const Book_Pooja_Payment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [package_popup, setPackageDetail] = useState(null)

    const { title, image, astro_name, price, id, description, short_description, pooja_id, poojalocation, package_detail, package_name, language, astro_user_id, pooja_date, from_time, muhurat_info } = location.state || {};
console.log("package_detail:", package_detail);

    // Function to handle booking after payment success
    const Handle_Book_pooja = async (transaction_id) => {
        const data = {
            id: id,
            title, image, astro_name, price: price, short_description, description, pooja_id, package_name: package_name, language: language, astro_user_id: astro_user_id, pooja_date, from_time, custom_detail: muhurat_info,
            location: poojalocation,
            paymentmethod: "Online",
            payment_status: "Success",
            transaction_id: transaction_id,
        };

        try {
            const token = User_Authentication();
            if (!token) {
                throw new Error("User token not found");
            }

            const response = await Book_Pooja(data, { Authorization: `Bearer ${token}` });
            if (response?.data?.status == "200") {
                toast("Pooja booked successfully");
                navigate("/user-my-pooja-list");
            }
        } catch (error) {
            toast("Failed to book pooja. Please try again.");
        }
    };

    // Callback when Razorpay payment is successful
    const handlePaymentSuccess = ({ transaction_id, payment_status }) => {
        if (payment_status == "Success") {
            Handle_Book_pooja(transaction_id);
        }
    };

    const formatTimeTo12Hour = (time) => {
        const [hours, minutes] = time.split(":");
        const intHours = parseInt(hours, 10);
        const ampm = intHours >= 12 ? "pm" : "am";
        const formattedHours = intHours % 12 || 12;
        return `${formattedHours}:${minutes} ${ampm}`;
    };
    const handle_Package_Popup = (package_detail) => {
        setPackageDetail(package_detail)
    }

    const close_Package_Popup = () => {
        setPackageDetail(null);
    };

    return (
        <div>
            {/*  */}
            <Header />
            <section className="gi-checkout-section py-[40px] text-[12px] max-[767px]:py-[30px]">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] relative">
                    <div className="flex flex-wrap w-full">
                        {/* <!-- Sidebar Area Start --> */}
                        <div className="gi-checkout-leftside px-[12px] min-[992px]:w-[66.66%] w-full max-[991px]:mt-[30px]">
                            {/* <!-- checkout content Start --> */}
                            <div className="gi-checkout-content">
                                <div className="gi-checkout-inner">
                                    <div className="gi-checkout-wrap bg-[#fff] mb-[30px]">
                                        <div className="gi-checkout-block gi-check-login">
                                            <h3 className="text-gray-900 font-semibold text-lg">
                                                Pooja Info</h3>
                                            <div className="gi-product-content mt-3 shadow-xl p-5">
                                                <div className="flex gap-6">
                                                    <div className="text-center">
                                                        <img width={130} height={130}
                                                            src={`${IMG_BASE_URL}${image}`}
                                                            className="m-auto rounded max-w-full z-[1]"
                                                            alt="Pooja Image"
                                                        />
                                                    </div>
                                                    <div className="grid grid-cols-3 gap-3 flex-1">
                                                        {title && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{title}</span>
                                                            </div>
                                                        )}

                                                        {astro_name && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pandit</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{astro_name}</span>
                                                            </div>
                                                        )}

                                                        {price && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Amount</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">Rs. {price}/-</span>
                                                            </div>
                                                        )}

                                                        {pooja_date && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja Date</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{pooja_date}</span>
                                                            </div>
                                                        )}

                                                        {from_time && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja Time</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{formatTimeTo12Hour(from_time)}</span>
                                                            </div>
                                                        )}

                                                        {package_name && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Package Name</h6>
                                                                <button className="text-[12px] text-gray-900 font-semibold border border-gray-200 hover:text-white hover:bg-red-500 py-1 px-2 rounded" onClick={() => { handle_Package_Popup(package_detail) }}>{package_detail?.name}</button>
                                                            </div>
                                                        )}

                                                        {poojalocation && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Location</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{poojalocation}</span>
                                                            </div>
                                                        )}

                                                        {language && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Language</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{language}</span>
                                                            </div>
                                                        )}
                                                        {package_detail?.number_of_day && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Days of Pooja</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{package_detail?.number_of_day}</span>
                                                            </div>
                                                        )}
                                                        {package_detail?.number_of_pandit && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Number Of Pandit</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{package_detail?.number_of_pandit}</span>
                                                            </div>
                                                        )}
                                                        {package_detail?.duration && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Pooja Duration</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{package_detail?.duration}</span>
                                                            </div>
                                                        )}
                                  
                                                        {muhurat_info && (
                                                            <div>
                                                                <h6 className="text-[12px] text-gray-400 font-medium">Additional Information</h6>
                                                                <span className="text-[13px] text-gray-900 font-semibold">{muhurat_info}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!--cart content End --> */}
                        </div>
                        <div className="gi-checkout-rightside min-[992px]:w-[33.33%] w-full mt-10">
                            <div className="gi-sidebar-wrap mb-[30px]">
                                {/* <!-- Sidebar Summary Block --> */}

                                <div className="gi-sidebar-wrap p-[15px] shadow-xl mb-[0]">
                                    {/* <!-- Sidebar Summary Block --> */}
                                    <div className="gi-sidebar-block">
                                        <h4 className="font-bold text-sm text-black mb-2">Order Summery</h4>

                                        <div className="gi-sb-block-content mb-[0] border-b-[0] mt-[15px]">
                                            <div className="gi-cart-summary-bottom">
                                                <div className="gi-cart-summary">
                                                    <div className="flex justify-between items-center mb-[10px]">
                                                        <span
                                                            className="text-left font-medium text-gray-900 text-[12px] leading-[24px] tracking-[0]">{title}</span>
                                                        <span
                                                            className="text-right text-[#000] text-[12px] leading-[24px] font-medium">Rs.{price}/-</span>
                                                    </div>
                                                    <div className="flex justify-between items-center mt-[10px] pt-[10px] border-t border-gray-200">
                                                        <span
                                                            className="text-left text-gray-900 text-[13px] font-semibold leading-[24px] tracking-[0]">Total Amount</span>
                                                        <span
                                                            className="text-right text-[#000] text-[13px] font-semibold leading-[24px] font-medium">Rs.{(price || 0)}/-</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-5">

                                                <Razor_Pay
                                                    Price={price}
                                                    onPaymentSuccess={handlePaymentSuccess}
                                                    buttonContent="Payment Now"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- Sidebar Summary Block --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {package_popup && (
                <div className='fixed inset-0 z-30 bg-gray-950/80 shadow-red-900/10 overflow-hidden rounded'>
                    <div className='max-w-80 m-auto flex flex-col h-full justify-center'>
                        <div className=' bg-white rounded-md overflow-hidden'>
                            <div className={`relative bg-[#FEE2E2]`}>
                                <div class="absolute bottom-[-55px] left-0 z-10">
                                    <svg class="w-full" height="122" viewBox="0 0 534 122" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 97.5001V0H533.333V97.5001C488.889 65.4241 444.444 65.4241 400 97.5001C355.556 129.576 311.111 129.576 266.667 97.5001C222.222 65.4241 177.778 65.4241 133.333 97.5001C88.8889 129.576 44.4444 129.576 0 97.5001Z" fill="#FEE2E2"></path></svg></div>
                                <div>
                                    <button
                                        onClick={close_Package_Popup}
                                        className="absolute right-0 top-0 z-50 px-2 bg-red-500 text-white rounded-full hover:bg-red-600"
                                    >
                                        X
                                    </button>

                                </div>
                                <div className='relative text-center p-4 z-20'>
                                    <div className='text-gray-800 font-semibold text-sm'>{package_popup?.name}</div>
                                    <h3 className='text-gray-900 font-bold text-lg'>₹ {package_popup?.amount}</h3>
                                </div>
                            </div>
                            <div className='p-4 mt-4 max-h-[80vh] overflow-y-auto thin-scrollbar'>
                                <ul className='text-[12px]/8 text-gray-900 font-medium'>
                                    {package_popup?.packages?.length > 0 && package_popup?.packages?.map((list_item) => (
                                        <li>
                                            {list_item?.is_included ? (<i class="gicon bg-green-100 mr-2 gi-check rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-green-700" aria-hidden="true"></i>) : (<i class="gicon bg-gray-200 mr-2 gi-close rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-gray-900" aria-hidden="true"></i>)}
                                            {list_item?.item_name}</li>
                                    ))}
                                </ul>
                                                       {/* Other Details */}
                                    <div className="mt-4 text-sm text-gray-700">
                                        {package_popup?.number_of_day && (
                                            <p>No of Days: <span className="font-semibold">{package_popup?.number_of_day}</span></p>

                                        )}
                                        {package_popup?.number_of_pandit && (
                                            <p>No of Pandits: <span className="font-semibold">{package_popup?.number_of_pandit}</span></p>

                                        )}
                                        {package_popup?.duration && (
                                            <p>Duration: <span className="font-semibold">{package_popup?.duration}</span></p>

                                        )}

                                    </div>

                                    {/* Note Section */}
                                    {package_popup?.notes && (
                                        <p className="mt-4 text-sm font-semibold text-red-800 leading-relaxed">
                                            Note: {package_popup?.notes}
                                        </p>
                                    )}

                                    {/* Procedure Section */}
                                    <div className="sub__title text-gray-800 text-[13px] font-medium mt-2" dangerouslySetInnerHTML={{ __html: ` ${package_popup?.procedure_involved} ` }} />

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Book_Pooja_Payment